import { getEnvironmentSettings } from '../../src/utils/appSettingsUtils';

const EnvironmentSettings = getEnvironmentSettings(ENVIRONMENT);

export default EnvironmentSettings;
